import { Component, OnInit } from '@angular/core';
import { FilterableService } from '../filterable-service';
import { AuthenticationService } from '../../../auth.service';
import { BaseService } from '../mesc.service';

@Component({
  selector: 'user-onboarding',
  templateUrl: './user-onboarding.component.html',
  styleUrls: ['./user-onboarding.component.css']
})
export class UserOnboardingComponent implements OnInit {
  selectedModule: any;
  selectedUser: any;
  show = false;
  moduleService: FilterableService;
  contactService: FilterableService = new FilterableService();

  constructor(
    private readonly authService: AuthenticationService,
    private readonly service: BaseService
  ) { }


  ngOnInit() {
    this.moduleService = this.authService.moduleService;
  }


  /**
   * 
   */
  onRequestAccess = () => this.show = true;


  /**
   * 
   */
  close = () => {
    this.show = false;
    this.selectedModule = null;
    this.selectedUser = null;
  };


  /**
   * 
   */
  handleModuleChange = (moduleId) => {
    this.selectedModule = this.moduleService.value.find(x => x.Id === moduleId);
    if (moduleId) {
      this.service.read('phf/CommonHandler/common/GetPHFUsers?moduleId=' + moduleId)
        .then(x => {
          const userAdmins = x.filter(u => u.Roles.some(r => r.toLowerCase().indexOf('admin') > -1));
          this.contactService.next(userAdmins.map(user => {
            user.cn = `${user.FirstName} ${user.LastName}`;
            return user;
          }));
        });
    }
    this.selectedUser = null;
  }


  /**
   * 
   */
  handleContactChange = (userId) => {
    this.selectedUser = this.contactService.value.find(x => x.Id === userId);
  }
}
